export default __webpack_public_path__ + "static/media/size.7b92d429.svg";